import { formatPrice } from '@helpers/payment'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { Heading } from '@ui-kit'
import { useTranslation } from 'react-i18next'
import { Row } from 'simple-flexbox'

export const TotalPrice = ({ totalPrice }: { totalPrice: number }) => {
  const { t } = useTranslation()

  const { accountCurrency } = useCheckoutContext()

  return (
    <Row justifyContent='space-between'>
      <Heading level={2} weight={600}>
        {t('checkout.configure.purchase.summary.total')}
      </Heading>

      <Heading level={2} weight={600} color='success'>
        {formatPrice(totalPrice)} {accountCurrency}
      </Heading>
    </Row>
  )
}
